// "Trust this device" ID for this browser (FECOA-2015). Sent in the request
// body the way the mobile app sends its own, because the API's HttpOnly cookie
// is dropped when the site and API are on different domains. The API stores
// only a SHA-256 fingerprint of it.
export const TRUSTED_DEVICE_STORAGE_KEY = 'trustedDeviceId';

// Same shape the API accepts (TRUSTED_DEVICE_ID_PATTERN in mfa_utils.py).
const TRUSTED_DEVICE_ID_PATTERN = /^[A-Za-z0-9._~-]{32,255}$/;

export const getTrustedDeviceId = () => {
  try {
    const stored = localStorage.getItem(TRUSTED_DEVICE_STORAGE_KEY);
    return stored && TRUSTED_DEVICE_ID_PATTERN.test(stored) ? stored : null;
  } catch {
    return null;
  }
};

export const getOrCreateTrustedDeviceId = () => {
  const existing = getTrustedDeviceId();
  if (existing) return existing;

  const bytes = crypto.getRandomValues(new Uint8Array(32));
  const deviceId = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  try {
    localStorage.setItem(TRUSTED_DEVICE_STORAGE_KEY, deviceId);
  } catch {
    // Storage blocked: the API still sets its cookie with this same ID.
  }
  return deviceId;
};
